import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d86743f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 2,
  class: "pay-item-wrap"
}
const _hoisted_3 = { class: "pay-item-time" }
const _hoisted_4 = {
  key: 0,
  class: "form-footer xag-page__footer device-replace-button-wrap"
}
const _hoisted_5 = { class: "button-wrap xag-flex-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useAppPay } from '@/compositions/usePay'
import { useClipboard } from '@/compositions/common'
import { commonErrorHandle, getErrorMessage } from '@/utils/error-handle'
import { Toast, PullRefresh, Button, Dialog } from 'vant'
import { ref, Ref, computed, onMounted } from 'vue'
import { useOrderApply } from '@/compositions/invoice/index'
import BlockkWrapper from './components/block-wrap.vue'
import {
  ServiceFeeDetail,
  confirmPayTechnicalSupportResult,
  ConfirmPayServiceChargePrams,
} from '@/types/malfunction-repair'
import {
  confirmPayServiceCharge,
  checkServiceChargePayStatus,
  getserviceChargeDetail,
  submitServiceChargeInvoice,
  getPayOrderDetail,
  getPayOrderPrice,
  submitServiceFeeTechnicalInvoice,
  cancelPayOrder,
  confirmPayTechnicalSupport,
} from '@/apis/malfunction-repair'
import {
  showToastLoading,
  showNormalToast,
  showToastSuccess,
  showConfirmModal,
  clearToast,
} from '@/utils/tools'
import RepairBillBlock from './components/service-bill/detail-bill-block.vue'
import wx from 'weixin-js-sdk'
import AppHeader from '@/components/Header.vue'
import OrderInoviceApply from '@/components/invoice/order-inovice-apply.vue'
import { ServiceChargeRuleMap, ServiceChargeStatusColorMap } from '@/defination/malfunction-repair'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'

import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'service-fee-invoice',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { removeServiceOrderKeepAlive, removeFaultOrderListItemKeepAlive } =
  useMalfunctionRepairStore()
const $router = useRouter()
const $route = useRoute()
const $store = useStore()
const serviceGuid = $route.query.serviceGuid as string
const sn = $route.query.sn as string
const confirmPayInfo: Ref<confirmPayTechnicalSupportResult | null> = ref(null)
const confirmPayParams: Ref<ConfirmPayServiceChargePrams | null> = ref(null)
const isMiniProgram = computed(() => {
  return $store.getters.isMiniProgram
})
let timeId: number
const guid = $route.query.guid as string
const refreshing = ref(false)
const {
  invoiceData,
  scrollToInvoiceDom,
  invoiceDomInit,
  changeHandle: invoiceChangeHandle,
  getOrderInvocieSubmitParams,
  getOrderInvocieData,
  verify: invoiceVerify,
} = useOrderApply()
let detail = ref<ServiceFeeDetail>({
  status: '',
  statusText: '',
  billInfo: {
    sum: '',
    billArr: [],
  },
  invoice_apply: null,
  pay_responsible_order: null,
})

let isDetail = computed(() => {
  return $route.query.isDetail === 'true'
})

const { compatibleWechatAndCmdPay, judgeCanUseMiniProgramPay } = useAppPay()

let canPay = computed(() => {
  return detail.value.status === 1
})

function handleSearchOrderPayStatus(pay_order_no: string, immediately = false) {
  // 查询单据支付状态
  let i = 0
  let searching = false
  function handleFn() {
    showToastLoading({
      message: '支付结果查询中',
    })
    if (i >= 12) {
      clearInterval(timeId)
      clearToast()
      Dialog.confirm({
        title: '查询结果失败',
        message: `支付订单号${pay_order_no}，请尝试继续校验，如需帮助请联系客服：400-780-3131`,
        confirmButtonText: '重新查询',
        cancelButtonText: '取消查询',
        className: 'reserve-dialog',
        width: 304,
      })
        .then(async () => {
          try {
            handleSearchOrderPayStatus(pay_order_no, true)
          } catch (error: any) {
            Dialog.close()
          }
        })
        .catch(() => {
          Dialog.close()
        })
    }
    if (searching) {
      return
    }
    searching = true
    checkServiceChargePayStatus(pay_order_no)
      .then((result) => {
        if (result.status === 2) {
          clearToast()
          // 跳转到支付成功页面
          clearInterval(timeId)
          showToastSuccess('支付成功')
          removeServiceOrderKeepAlive()
          removeFaultOrderListItemKeepAlive()
          setTimeout(() => {
            $router.go(-1)
          }, 500)
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        searching = false
        i++
      })
  }
  if (immediately) {
    handleFn()
  }
  //
  timeId = setInterval(async () => {
    // 如果查询时间超过1分钟 那么停止查询并提示
    handleFn()
  }, 5000)
}
// 支付成功页面
const getCbPageUrl = (): string => {
  return `/malfunction-repair/pay-success/${sn}/${serviceGuid}/${detail.value.billInfo.sum}/${guid}/technicalSupport`
}
async function beforePayHandle(mode: string) {
  if (!invoiceVerify()) {
    return
  }
  try {
    await showConfirmModal({
      title: '提示',
      message: '是否确认支付',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
      cancelButtonText: '取消',
      confirmButtonText: '确定',
    })
  } catch (error) {
    return
  }
  try {
    confirmPayInfo.value ? '' : await getPayInfoHandle()
    payInfoHandle()
  } catch (error) {
    return
  }
  return true
}

async function getPayInfoHandle() {
  // 获取支付相关信息
  const canUseCmbPay = await judgeCanUseMiniProgramPay()
  try {
    const params = {
      from: isMiniProgram.value ? 'applets' : 'app',
      payment_platform: canUseCmbPay ? 'merchants_bank' : 'wechat',
      callback_page_url: window.location.origin + getCbPageUrl(),
      guid,
    }
    showToastLoading()
    const result = await confirmPayTechnicalSupport(params)
    if (Number(result.price) !== Number(detail.value.billInfo.sum)) {
      Dialog.confirm({
        title: '提示',
        message: `订单金额已发生变化，请点击确定刷新账单页面！`,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        className: 'reserve-dialog',
        width: 304,
      })
        .then(async () => {
          try {
            initPageDetail()
          } catch (error: any) {
            Dialog.close()
          }
        })
        .catch(() => {
          Dialog.close()
        })
      return
    }
    clearToast()
    confirmPayInfo.value = result
    confirmPayParams.value = params
  } catch (error) {
    // 如果获取支付信息失败就刷新页面即可
    initPageDetail()
    return Promise.reject(error)
  }
}
// 更新单据发票信息
async function updateInvoiceInfoHandle(): Promise<void> {
  let invoiceInfo = getOrderInvocieData()
  const data = invoiceData.value
  const params = {
    invoice_type: invoiceInfo?.invoice_type,
    bill_type: invoiceInfo?.bill_type,
    header: invoiceInfo?.header,
    taxpayer_no: invoiceInfo?.taxpayer_no,
    pay_responsible_work_order_guid: guid,
  }
  try {
    await submitServiceFeeTechnicalInvoice(params)
  } catch (error) {
    console.log('error', error)
    const message = `发票选择失败: ${getErrorMessage(error)}`
    showNormalToast(message)
  }
  return null
}
async function halfPayHandle() {
  const result = confirmPayInfo.value
  const params = confirmPayParams.value
  if (params.from === 'applets') {
    // 小程序支付
    wx.miniProgram.navigateTo({
      url: '/pages/user/pay?guid=' + result.pay_order_no,
    })
  } else {
    //appHost.onPay(result.pay_order_no)
    const userAgree = compatibleWechatAndCmdPay(result.pay_order_no)
    userAgree && handleSearchOrderPayStatus(result.pay_order_no)
  }
}

function payInfoHandle() {
  halfPayHandle()
  removeServiceOrderKeepAlive()
  removeFaultOrderListItemKeepAlive()
}

let payItemArr = computed(() => {
  let arr = []
  if (isDetail.value && detail.value) {
    if (detail.value?.status === 2) {
      arr.push({
        title: '已支付',
        time: detail.value?.pay_responsible_order.created_at,
        color: 'rgba(0, 195, 120, 1)',
      })
    }
    if (detail.value?.status === 3) {
      arr.push(
        {
          title: '已退款',
          time: detail.value?.pay_responsible_order.updated_at,
          color: 'rgba(247, 152, 28, 1)',
        },
        {
          title: '已支付',
          time: detail.value?.pay_responsible_order.created_at,
          color: 'rgba(0, 195, 120, 1)',
        }
      )
    }
  }
  return arr
})

async function initPageDetail(refresh = false) {
  if (!refresh) {
    showToastLoading()
  }
  if (!isDetail.value && invoiceData.value && invoiceData.value?.invoice_guid) {
    await updateInvoiceInfoHandle()
  }
  try {
    let data = await Promise.all([getPayOrderDetail(guid), getPayOrderPrice(guid)])
    detail.value.status = data[0].status
    detail.value.billInfo.billArr = [
      {
        title: '定责服务费',
        titleRule: '',
        num: 1,
        price: String(data[1].price),
        sum: String(data[1].price),
      },
    ]
    detail.value.billInfo.sum = String(data[1].price)
    // detail.value.guid = getserviceChargeDetailData.guid
    if (data[0].pay_responsible_invoice_info) {
      let pay_responsible_invoice_info = data[0].pay_responsible_invoice_info
      detail.value.invoice_apply = {
        header: pay_responsible_invoice_info.header,
        invoice_type: pay_responsible_invoice_info.invoice_type,
        invoice_guid: pay_responsible_invoice_info.guid,
        taxpayer_no: pay_responsible_invoice_info.taxpayer_no,
        bill_type: pay_responsible_invoice_info.bill_type,
      }
    }
    detail.value.pay_responsible_order = data[0].pay_responsible_order
    invoiceChangeHandle(detail.value.invoice_apply)
    Toast.clear()
  } catch (error) {
    Toast.clear()
    commonErrorHandle(error)
  }
  refreshing.value = false
}

async function cancelTechnicalHandle() {
  try {
    await showConfirmModal({
      title: '提示',
      message: '是否确认取消工单?',
      cancelButtonText: '我再想想',
      confirmButtonText: '确定取消',
      className: 'repair-dialog',
    })
    showToastLoading()
    await cancelPayOrder(guid)
    showToastSuccess('已取消工单')
    $router.go(-1)
  } catch (error) {
    console.log('error', error)
  }
  clearToast()
}

const onRefresh = () => {
  refreshing.value = true
  initPageDetail(true)
}
onMounted(() => {
  initPageDetail()
})

let canSubmit = computed(() => {
  return detail.value.invoice_apply
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "付费技术支持订单" }),
    _createVNode(_unref(PullRefresh), {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh,
      class: "detail-wrap"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_unref(detail).billInfo.billArr.length)
            ? (_openBlock(), _createBlock(RepairBillBlock, {
                key: 0,
                class: "block-item",
                "pay-info": _unref(detail).billInfo
              }, null, 8, ["pay-info"]))
            : _createCommentVNode("", true),
          (_unref(detail).billInfo.billArr.length)
            ? (_openBlock(), _createBlock(OrderInoviceApply, {
                key: 1,
                invoiceData: _unref(detail)?.invoice_apply || null,
                url: _unref(detail)?.pay_responsible_invoice_info?.url,
                onInit: _unref(invoiceDomInit),
                isDetail: _unref(isDetail)
              }, null, 8, ["invoiceData", "url", "onInit", "isDetail"]))
            : _createCommentVNode("", true),
          (_unref(payItemArr).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(payItemArr), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "pay-item",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: "pay-item-title",
                      style: _normalizeStyle({ color: item.color })
                    }, _toDisplayString(item.title), 5),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(item.time), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(canPay))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Button), {
              square: "",
              class: "xa-vant-button pay-behalf",
              onClick: cancelTechnicalHandle
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消工单")
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              square: "",
              disabled: !_unref(canSubmit),
              type: "success",
              class: "xa-vant-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (beforePayHandle('half')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认支付")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_6
  ], 64))
}
}

})